/* eslint-disable */
const getOnboardingLoMonthlyAmount = state => {
  return state.onboardingLoMonthlyAmount;
};
const getActivateCustomerType = state => {
  return state.activateCustomerType;
};
const getLoDetails = state => {
  return state.loDetails;
};
const getLuxOnboardingStates = state => {
  return state.luxOnboardingStatus;
};
const getLuxPaymentStates = state => {
  return state.luxPaymentStatus;
};
const getUsers = state => {
  return state.userList;
};
const getUsersAdmin = state => {
  return state.userListAdmin;
};
const getGroups = state => {
  return state.groupList;
};
const getSubgroups = state => {
  return state.subgroupList;
};
const getGroupItems = state => {
  return state.groupitemList;
};
const getGroupUsers = state => {
  return state.groupUsers;
};
const getInstalls = state => {
  return state.installs;
};
const getInstallss = state => {
  return state.installss;
};
const getEmails = state => {
  return state.emailList;
};
const getSms = state => {
  return state.smsList;
};
const isHome = state => {
  return state.isHome;
};
const getAccess = state => {
  return state.userAccess;
};
const getUserSession = state => {
  return state.loggedInUser;
};
const getUserAmount = state => {
  return state.userAmount;
};
const getDummy = state => {
  return state.dummy;
};
const getDevices = state => {
  return state.deviceList;
};
const getUserById = state => id => {
  return state.userList.find(user => user.id === id);
};
const getUserByEmail = state => email => {
  return state.userList.find(user => user.email === email);
};
const getDeviceById = state => id => {
  return state.deviceList.find(device => device.id === id);
};
const getDeviceByUserId = state => id => {
  return state.deviceList.filter(device => device.user.data.id === id);
};
const getUserByDevice = state => id => {
  return state.deviceList.filter(device => device.user.data.solarKitIds === id);
};
const getDrawerMode = state => {
  return state.drawerMode;
};
const getRole = state => {
  return state.roles;
};
const getRoleAdmin = state => {
  return state.rolesAdmin;
};
const getTheme = state => {
  return state.activeTheme;
};
const themeList = state => {
  return {
    light: state.defaultTheme,
    dark: state.darkTheme
  };
};
const getDeviceWarning = state => device => {
  return state.devicesWarning[device] ? state.devicesWarning[device] : null;
};
const getGlobalTableOptions = state => state.globalTableOptions;
const filterSectorVal = state => state.filterSectorVal;
const DeviceList = state => state.allDevices;
const isSidebarCollapsed = state => state.isSidebarCollapsed;
const OffDeviceList = state => state.allOffDevices;
const graphDeviceDetails = state => state.allGraphDevices;
const devicePayload = state => state.devicePayload; //
const loadingState = state => state.loadingState; //
const offLineDeviceList = state => state.offLineDevices; //
const alarmDevices = state => state.alarmDevices; //
const onLineDevices = state => state.onLineDevices; //
const uniqueFV = state => state.uniqueFV; //
const filteredAllDevices = state => state.filteredAllDevices;
const filteredOnlineDevices = state => state.filteredOnlineDevices;
const filteredOffLineDevices = state => state.filteredOffLineDevices;
const filteredAlarmDevices = state => state.filteredAlarmDevices;
const filterFirmWarVersion = state => state.filterFirmWarVersion; //
const filterPaymentModel = state => state.filterPaymentModel; //
const criticalSystems = state => state.criticalSystems; //
const uniqueSectors = state => state.uniqueSectors; //
const uniquePaymentModel = state => state.uniquePaymentModel; //
const getPerformanceFilter = state => state.performanceFilter; //
const getDeviceCurrentSettings = state => state.deviceCurrentSettings[0] || []; //
//
const getloggedinUserRole = state => state.loggedinUserRole;
const getloggedinUserInstallationCount = state =>
  state.loggedinUserInstallationCount;
const combinedDevices = state => state.allOffDevices.concat(state.allDevices);

const getOsCustomer = state => state.osCustomer;
const getCustomerProductOptions = state => state.customerProductOptions;
const getUserNotifications = state => state.userNotifications; //
const getAssignedDevices = state => state.assignedDevices;
const getActiveDeviceDaysToExpire = state => state.activeDeviceDaysToExpire;

export default {
  getOnboardingLoMonthlyAmount,
  getActivateCustomerType,
  getLoDetails,
  getLuxOnboardingStates,
  getLuxPaymentStates,
  isSidebarCollapsed,
  getTheme,
  getUserById,
  loadingState,
  getUserByDevice,
  getUserByEmail,
  getDeviceById,
  getUsers,
  getUsersAdmin,
  getInstalls,
  getInstallss,
  getGroups,
  getSubgroups,
  getGroupItems,
  getGroupUsers,
  getEmails,
  getSms,
  getDeviceWarning,
  getDummy,
  devicePayload,
  getDevices,
  getDeviceByUserId,
  getUserSession,
  getUserAmount,
  getAccess,
  isHome,
  getDrawerMode,
  DeviceList,
  OffDeviceList,
  combinedDevices,
  getRole,
  getRoleAdmin,
  themeList,
  graphDeviceDetails,
  offLineDeviceList,
  alarmDevices,
  onLineDevices,
  uniqueFV,
  filteredAllDevices,
  filteredOnlineDevices,
  filteredAlarmDevices,
  filteredOffLineDevices,
  filterFirmWarVersion,
  filterPaymentModel,
  uniqueSectors,
  filterSectorVal,
  uniquePaymentModel,
  getGlobalTableOptions,
  getPerformanceFilter,
  criticalSystems,
  getDeviceCurrentSettings,
  getOsCustomer,
  getCustomerProductOptions,
  getUserNotifications,
  getAssignedDevices,
  getActiveDeviceDaysToExpire,
  getloggedinUserInstallationCount,
  getloggedinUserRole
};



// WEBPACK FOOTER //
// ./src/store/getters.js